import { Injectable } from '@angular/core';
import { combineLatest, firstValueFrom } from 'rxjs';
import { AgGridApiBusService } from '../ag-grid-api-bus/ag-grid-api-bus.service';
import { map, switchMap } from 'rxjs/operators';
import { AgGridAngular } from '@ag-grid-community/angular';
import { ColumnApi, ColumnState } from '@ag-grid-community/core';

@Injectable()
export class CommonGridColumnApiService {
    public readonly columnApi: Promise<ColumnApi>;

    constructor(private agGridApiBusService: AgGridApiBusService) {
        this.columnApi = firstValueFrom(
            this.agGridApiBusService.agGridComponent.pipe(
                switchMap((agGridApi: AgGridAngular) => combineLatest([agGridApi.firstDataRendered, agGridApi.gridReady])),
                map(([, gridOptions]) => gridOptions.columnApi)
            )
        );
    }

    public async safeExecute<FnName extends keyof ColumnApi>(functionName: FnName, ...args: Parameters<ColumnApi[FnName]>): Promise<void> {
        const columnApi = await this.columnApi;
        const fn = columnApi[functionName] as unknown as (...fnArgs: Parameters<ColumnApi[FnName]>) => unknown;
        fn.apply(columnApi, args);
    }

    public applyColumnState(columnsStates: ColumnState[]): void {
        this.safeExecute('applyColumnState', {
            state: columnsStates,
            applyOrder: true
        });
    }

    public setColumnsVisible(keys: string[], visible: boolean): void {
        this.safeExecute('setColumnsVisible', keys, visible);
    }
}
